$( function() {
	requestAnimationFrame( updateParallaxPosition );
} );

function updateParallaxPosition() {
	requestAnimationFrame( updateParallaxPosition );
	if ( $( window ).width() > 991 && !isTouchDevice() ) {
		const pageHeight = window.innerHeight;
		const pageYOffset = window.pageYOffset;
		const pageCenter = pageYOffset + pageHeight / 2;

		for ( const element of document.getElementsByClassName( 'parallax' ) ) {
			const clientRect = element.getBoundingClientRect();
			const center = pageYOffset + clientRect.top + clientRect.height / 2;
			const offset = (center - pageCenter) / (pageHeight / 2);

			const parallaxShiftXInPixel = element.getAttribute( 'data-parallax-shift-x' ) || '0px';
			const parallaxShiftYInPixel = element.getAttribute( 'data-parallax-shift-y' ) || '0px';
			element.style.transform = `translate(calc(${offset} * ${parallaxShiftXInPixel}), calc(${offset} * ${parallaxShiftYInPixel}))`;
		}
	} else {
		for ( const element of document.querySelectorAll( '.parallax, .header-parallax' ) ) {
			element.style.transform = 'translate(0, 0)';
		}
	}
}

function isTouchDevice() {
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}
